// Remember where someone was going when sign-in interrupted them (e.g. a product link in a marketing
// email), so they land there afterwards instead of on the home page. Session-only; same-site paths only.
const KEY = 't8_return_to';
const safePath = (p) => (typeof p === 'string' && p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/login') ? p : null);

export function rememberReturn(path) {
  const p = safePath(path);
  if (!p || p === '/') return;
  try {
    sessionStorage.setItem(KEY, p);
  } catch {
    /* storage unavailable — they'll land on home */
  }
}

/** The remembered path (once), or null. */
export function takeReturn() {
  try {
    const p = safePath(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return p;
  } catch {
    return null;
  }
}
